import { Component, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { Location } from "@angular/common";
import { RazorpayService } from "src/app/services/razorpay.service";
import { Meta, Title } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-pricing",
  templateUrl: "./pricing.component.html",
  styleUrls: ["./pricing.component.scss"],
})
export class PricingComponent implements OnInit {
  user: any;
  message: string = "";
  price: number = 0;
  constructor(
    private dataService: DataService,
    private afs: AngularFirestore,
    public router: Router,
    private title: Title,
    private razorpay: RazorpayService,
    private _snackBar: MatSnackBar,
     private meta: Meta,
  ) {
    //  this.meta.addTag({ name: "description", content: "New" });
  }

  async ngOnInit(): Promise<void> {
    this.user = this.dataService.userDetail;
    if(this.user && this.user.isSubscribed) {
      this.router.navigate(["/"]);
      return;
    }
    this.title.setTitle(`Pricing | Illusbook`);
    (await this.dataService.getPaymentAmountService()).subscribe(
      (singleservice) => {
        this.price = singleservice[0]["price"];
      }
    );
  }

  updateUserToSubscribed() {
    this.dataService.userDetail = this.user;
    if (!this.user || !this.user.id) {
      const currentUrl = this.router.url;
      sessionStorage.setItem("returnUrl", currentUrl);
      this.router.navigate(["/login"]);
    } else if (this.user && this.user.id) {
      sessionStorage.setItem(
        "userData",
        window.btoa(JSON.stringify(this.user))
      );
      this.submitContent();
    }
  }

  async submitContent() {
    if (!this.user || !this.user.id) {
      const currentUrl = this.router.url;
      sessionStorage.setItem("returnUrl", currentUrl);
      this.router.navigate(["/login"]);
      return false;
    } else if (this.user && this.user.id) {
      let userDetail = {
        id: this.user.id,
        name: this.user.name,
        email: this.user.email,
        phone: this.user.phone || "",
      };
      let amount = this.price;
      this.razorpay.payWithRazor(
        amount,
        userDetail,
        async (paymentId: string) => {
          this.user.isSubscribed = true;

          const fromDate = new Date();
          const toDate = new Date();
          toDate.setDate(fromDate.getDate() + 30);

          this.user.subscriptionFrom = fromDate.toISOString();
          this.user.subscriptionTo = toDate.toISOString();
          this.user.totalDays = 30;
          this.user.expiryDate = toDate.toISOString();

          const document = this.afs.doc("/userMaster/" + this.user.id);
          await document.update(this.user);
          this.dataService.userDetail = this.user;
          sessionStorage.setItem(
            "userData",
            window.btoa(JSON.stringify(this.user))
          );
          this.dataService.userDetails();
          let data = {
            userId: this.user.id,
            name: this.user.name,
            email: this.user.email,
            subscriptionFrom: this.user.subscriptionFrom,
            subscriptionTo: this.user.subscriptionTo,
            totalDays: this.user.totalDays,
            expiryDate: this.user.expiryDate,
            createdAt: new Date().toISOString(),
            createdOn: +new Date(),
            razorpayPaymentId: paymentId,
          };

          await this.afs.collection("subscriptionMaster").add(data);
           this._snackBar.open("🎉 Your subscription is successfully activated!", "Okay", {
            duration: 1000,
          });

          setTimeout(() => {
            this.message = "";
            const returnUrl = sessionStorage.getItem("returnUrl") || "/";
            window.location.href = returnUrl;
          }, 2000);
        }
      );
      return true;
    } else {
      return false;
    }
  }
}
